
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-learn/[slug]",
      function () {
        return require("private-next-pages/how-to-learn/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-learn/[slug]"])
      });
    }
  